const Fetch = async (url, clientId) => {
    const response =  await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'clientId': clientId,
            'idToken' : localStorage.getItem('user'),
            'x-platform' : ' true'
        }
    });

    if(response.status === 401) {
        localStorage.removeItem('user');
        window.location.href = '/unauthorized';
    }

    if(!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
}

export default Fetch;